export default __webpack_public_path__ + "static/media/Background_qa.cd95884a.png";